<template>
  <div class="text-nowrap">
    <div
      v-for="(item, index) in currentActions"
      :key="index"
      class="d-inline-block mx-2"
    >
      <a
        v-if="item === 'view' && permission('view-pdf') && certificate"
        :href="certificate"
        target="_blank"
        class="icon"
        :class="resultIconClass"
        :disabled="
          resultIconClass == 'badge badge-icon icon-not-started cursor-auto'
        "
      ></a>

      <div
        v-if="item === 'view' && permission('view-pdf') && !certificate"
        class="icon badge badge-icon icon-not-started badge-not-started"
      ></div>
      <a
        v-if="
          item === 'upload' &&
          habilitation.uploadedFile &&
          permission('upload-pdf')
        "
        @click.prevent="showUploadModal()"
        href="#"
        class="icon icon-upload-secondary"
        aria-label=""
      ></a>
      <a
        v-if="
          item === 'print' &&
          certificate &&
          habilitation.printCertificate &&
          permission('print-pdf')
        "
        href="#"
        @click.prevent="showPrintModal()"
        class="icon icon-print"
        aria-label=""
      ></a>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'HabilitationAction',
  props: ['habilitation'],
  computed: {
    ...mapFields(['user']),
    resultIconClass() {
      return this.habilitation?.certificate
        ? 'icon-eye'
        : 'badge badge-icon icon-not-started cursor-auto'
    },
    certificate() {
      return this.$lodash.get(this.habilitation, 'certificate', false) || false
    },
    currentActions() {
      const uploadStatus =
        +this.$lodash.get(this.habilitation, 'certficateUploadStatus', false) ||
        false
      const uploadedFile =
        +this.$lodash.get(this.habilitation, 'uploadedFile', false) || false
      const clientType =
        +this.$lodash.get(this.user, 'clientType', false) || false

      if (clientType === 6 || clientType === 4) {
        return ['view', 'upload', 'print']
      } else {
        switch (uploadStatus) {
          case 3:
            return ['view']
          case 2:
            if (uploadedFile) return ['view']
            else return ['print']
          case 1:
            if (uploadedFile && this.permission('view-pdf')) return ['view']
            else if (!uploadedFile && this.permission('upload-pdf'))
              return ['upload']
        }
      }
    },
  },
  methods: {
    showUploadModal() {
      this.$bus.$emit('upload-modal.show', this.habilitation)
    },
    showPrintModal() {
      this.$bus.$emit('print-modal.show', this.habilitation)
    },
    permission(perm) {
      const establishmentId =
        this.$lodash.get(this.habilitation, 'establishmentId', false) || -1
      const establishment = this.user.permissions.find(
        (i) => i.establishment.id === establishmentId
      )
      return establishment ? Boolean(establishment.establishment[perm]) : false
    },
  },
}
</script>

<style scoped></style>
